export default "__VITE_ASSET__B6MKlXPW__"